import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import uniqBy from 'lodash/uniqBy';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import {
  // useEffect,
  useRef,
  useState
} from 'react';

// import {
//   redirect,
//   sendData,
//   sendJson,
//   sendStatusCode,
// } from 'next/dist/next-server/server/api-utils';
import CardFull from 'src/components/cards/card-full';
import CardH from 'src/components/cards/card-h';
import CardV from 'src/components/cards/card-v';
import Layout from 'src/components/layouts';
// import { isShouldFetch } from 'src/utils/detect-scrolling';
import { APP_IMG, APP_URL, IS_NO_ROBOT_INDEX, SHOW_COMMEMORATE } from 'src/constants';
import {
  IMAGE_DEFAULT,
  WEB_DESC,
  WEB_KEYWORD,
  WEB_NAME,
  WEB_TITLE,
  WEB_URL
} from 'src/constants/layout';
// import EmptyArticle from 'src/components/empty';

// import { useFetch } from 'services/useFetch';
import { arrayEmpty, escapeChar, rewriteTxt, timestamp, useDesktop } from 'src/utils/helper';
// import { KEY_HEADING } from 'src/components/heading/heading-page';
import PageError from 'pages/404';
import HeadingTag, { KEY_HEADING_TAG } from 'src/components/heading/heading-tag';

import parse from 'html-react-parser';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import InfiniteScroll from 'react-infinite-scroller';
import { KEY_ADS_POSITION } from 'src/components/ads/dynamic-ads';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import {
  DATALAYER_TYPE
} from 'src/utils/datalayer/send-datalayer';
import { GET, GET_ARTICLES } from 'src/utils/services';
import useUser from 'src/utils/useUser';
// import WidgetCookie from 'src/components/widgets/widget-cookie';
const DynamicAds = dynamic(import('src/components/ads/dynamic-ads'), { ssr: true });
const SectionAffiliate = dynamic(import('src/components/sections/section-event/section-affiliate'));
const PageCategory = ({
  articles,
  nextArticles,
  category,
  subCategory,
  lastNews,
  // related,
  meta,
  ads,
  dataAffiliate,
  dataAdsHeader
}) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (!articles) return <PageError dataAdsHeader={dataAdsHeader} sessionSevId={sessionSevId} />;
  // if (arrayEmpty(articles)) return <EmptyArticle type={KEY_HEADING.CATEGORY} data={subCategory.th ? subCategory?.th : category?.th} lastNews={lastNews} />;

  let setItemListElement = '';
  let baseUrlCategory = `${APP_URL}/category/${category?.en}`;

  /* -------------------------------- START : LOADMORE -------------------------------- */
  const nextLinkRef = useRef(nextArticles);
  const listArticlesRef = useRef(articles);
  const [listArticles, setListArticles] = useState(articles);
  const router = useRouter();
  const [closeAd, setCloseBoxAd] = useState(true);

  const handleCloseBoxAd = () => {
    setCloseBoxAd(false);
  };
  const handleLoad = async () => {
    try {
      if (nextArticles) {
        // console.log('#3', nextLinkRef.current);
        // console.log('#3', nextLinkRef.current);
        const resData = await GET_ARTICLES(
          `${nextLinkRef.current || ''}`,
          false,
          true
        );
        if (!isEmpty(resData?.data)) {
          nextLinkRef.current = resData?.nextTo || resData?.links?.next;
          const newLists = [...listArticlesRef.current, ...resData?.data];
          listArticlesRef.current = uniqBy(newLists, 'id');

          setListArticles(listArticlesRef.current);
        }
      }
    } catch (err) {
      console.error(
        `${timestamp()} ==========> LOAD_CATEGORY_LIST ERROR : ${nextLinkRef?.current
        }`,
        err
      );
    }
  };

  /* ----------------------------- END : LOADMORE ----------------------------- */

  const _article = {
    title: meta?.title || WEB_TITLE,
    description: meta?.description || WEB_DESC,
    keyword: meta?.keyword || WEB_KEYWORD
  };
  const cloneArticles = [...listArticles];
  const firstData = cloneArticles.shift();
  const cloneBlockSide = lastNews && [...lastNews.slice(0, 4)];

  const articleDescriptionSeo = escapeChar(_article?.description);

  if (subCategory.en != null) {
    baseUrlCategory = `${APP_URL}/category/${category?.en}/${subCategory?.en}`;
    setItemListElement = `[
      {
        "@type": "ListItem",
        "position": 1,
        "name": "หน้าแรก",
        "item": "${APP_URL}"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "${category?.th}",
        "item": "${APP_URL}/category/${category?.en}"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "${subCategory?.th}",
        "item": "${baseUrlCategory}"
      }
    ]`;
  } else {
    baseUrlCategory = `${APP_URL}/category/${category?.en}`;
    setItemListElement = `[
      {
        "@type": "ListItem",
        "position": 1,
        "name": "หน้าแรก",
        "item": "${APP_URL}"
      },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "${category?.th}",
          "item": "${APP_URL}/category/${category?.en}"
        }
      ]`;
  }
  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo
        noindex={IS_NO_ROBOT_INDEX}
        nofollow={IS_NO_ROBOT_INDEX}
        title={_article?.title}
        description={_article?.description}
        openGraph={{
          type: 'article',
          locale: 'th_TH',
          site_name: WEB_NAME,
          title: _article?.title,
          description: _article?.description,
          url: baseUrlCategory,
          images: [
            {
              url: IMAGE_DEFAULT,
              width: '1920',
              height: '1080',
              alt: WEB_NAME
            }
          ]
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: _article?.keyword
          }
        ]} />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={baseUrlCategory} />
        <meta property='twitter:title' content={_article?.title} />
        <meta property='twitter:description' content={_article?.description} />
        <meta property='twitter:image' content={IMAGE_DEFAULT} />

        {/* ------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
              __th_page="${subCategory?.en ? subCategory.en : category?.en}";
            `
          }}
        />

        {/* ---------------------------- SNIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "${WEB_NAME}",
                "url": "${WEB_URL.WEB}",
                "description": "${articleDescriptionSeo}",
                "sameAs": [
                  "${WEB_URL.FACEBOOK}",
                  "${WEB_URL.TWITTER}",
                  "${WEB_URL.YOUTUBE}",
                  "${WEB_URL.LINE}",
                  "${WEB_URL.INSTAGRAM}"
                ],
                "potentialAction": {
                  "@type": "SearchAction",
                  "target": "${WEB_URL.WEB}search?q={search_term_string}",
                  "query-input": "required name=search_term_string"
                }
              }
            `
          }}
        />

        {/* ---------------------------- SNIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                {
                  "@context": "http://schema.org",
                  "@type": "WebPage",
                  "name": "${subCategory?.th ? subCategory.th : category?.th
              }",
                  "description": "${articleDescriptionSeo}",
                  "publisher": {
                    "@type": "ProfilePage",
                    "name": "${WEB_NAME}"
                  }
                }
              `
          }}
        />

        {/* ------------------------ SNIPPET : BreadcrumbList ------------------------ */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
              {
                "@context": "http://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": ${setItemListElement}
              }
            `
          }}
        />

        {/* -------------------------------- ADS : PPN ------------------------------- */}
        {!useDesktop() && !isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}
        {/* ------------------------ ADS : PPN ------------------------ */}
        <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
        <script type='text/javascript' dangerouslySetInnerHTML={{
          __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
        }} />

      </Head>
      {/* -------------------------------------------------------------------------- */}
      {!isEmpty(dataAffiliate) && <SectionAffiliate position={4} data={dataAffiliate} />}

      <Layout ads={ads} sessionSevId={sessionSevId}>
        <section id='category-area' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.5)' : 'unset' }} >
          <div className='category-area section-wrapper'>
            <div className='container'>
              <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />
              {/* ---------------------------- BLOCKTOP : START --------------------------- */}
              <div className='row mb-0 mb-lg-2'>
                <div className='col-12 col-lg-8 mb-35 d-block'>
                  {/* ------------------------------ HEADING : START ----------------------------- */}
                  <div className='breadcrumb-area'>
                    <div className='breadcrumb-title --none-border'>
                      <h1 className='category unset'>{subCategory.th ? subCategory.th : category?.th}</h1>
                      <h2 className='hide position-absolute'> ข่าวทั้งหมด </h2>
                      <ul>
                        <li>
                          <a href='/'>หน้าแรก</a></li>
                        <li>ข่าวทั้งหมด</li>
                      </ul>
                    </div>
                    {/* ------------------------------ HEADING : END ----------------------------- */}
                  </div>
                  {firstData
                    ? <CardFull
                      showHeadingTag={false}
                      data={firstData}
                      path={firstData?.link}
                      heightImg='--large'
                      //! DATALAYER
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'ข่าวทั้งหมด',
                        position: 'ใต้:header',
                        data: {
                          block: '1',
                          title: firstData?.title,
                          heading: firstData?.subCategory?.th
                        }
                      }}
                    />
                    : <div className='error-content'>
                      <img className='no-article' src={`${APP_IMG}/images/tnews-preload.svg`} alt='no-article' />
                    </div>
                  }
                </div>

                {!arrayEmpty(cloneBlockSide) &&
                  <div className={`col-12 col-lg-4 pt-10 d-none d-lg-block ${!firstData ? 'show-mb' : ''}`}>
                    <div className='section-title --red'>
                      <HeadingTag heading={'ข่าวล่าสุด'} type={KEY_HEADING_TAG.DEFAULT} />
                    </div>
                    <div className='row'>
                      {cloneBlockSide.map((item, index) => (
                        <div key={index} className='col-12 col-md-6 col-lg-12' >
                          <CardH
                            data={item}
                            path={item.link}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              section: 'ข่าวล่าสุด',
                              position: 'ใต้:header',
                              data: {
                                block: '2',
                                title: item.title,
                                heading: 'ข่าวล่าสุด',
                                index: index + 1
                              }
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                }
              </div>
              {/* ---------------------------- BLOCKTOP : END --------------------------- */}

              {/* ---------------------------- BLOCKLIST : START --------------------------- */}
              {
                listArticles.length > 1 &&
                <InfiniteScroll
                  className='infinite-scroll'
                  pageStart={0}
                  loadMore={handleLoad}
                  hasMore={true}
                  loader={<div className='fetching'> Loading... </div>}
                  threshold={2000}
                // useWindow={false}
                >
                  <div className='row '>
                    {cloneArticles.map((item, index) => (
                      <div
                        id={index + 1}
                        key={index}
                        className='col-6 col-md-4 col-lg-3 bt-0' >
                        <CardV
                          data={item}
                          path={item.link}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'ข่าวทั้งหมด',
                            position: 'ใต้:header',
                            data: {
                              title: item?.title,
                              heading: item?.subCategory?.th,
                              index: index + 2
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </InfiniteScroll>
              }
              {/* {!arrayEmpty(cloneArticles) &&
                <div className='row '>
                  {cloneArticles.map((item, index) => (
                    <div
                      id={index + 1}
                      key={index}
                      className='col-6 col-md-4 col-lg-3 bt-0' >
                      <CardV
                        data={item}
                        path={item.link}
                      />
                    </div>
                  ))}
                </div>} */}

              {/* ---------------------------- BLOCKLIST : END --------------------------- */}
            </div>
          </div>
                      <div className={`close-box-ads ${!closeAd ? 'close' : 'open'}`}>
                <div onClick={handleCloseBoxAd} className='close-box'>
                  <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />
                </div>
            </div>
        </section>
      </Layout>
    </>
  );
};

export async function getServerSideProps ({ res, query }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    articles: null,
    category: null,
    subCategory: null,
    lastNews: null,
    related: null,
    meta: null,
    nextArticles: null,
    queryCategory: null,
    dataAffiliate: [],
    dataAdsHeader: null,
    ads: []
  };
  const adsHeaders = await GET('/api/headerAds');
  if (!isEmpty(adsHeaders)) {
    initProps.dataAdsHeader = adsHeaders;
  }
  initProps.queryCategory = query;
  let uri = `categories/${rewriteTxt(query?.cid)}`;
  if (query?.sub) {
    if (rewriteTxt(query?.sub) === 'latest-news') {
      uri = `categories/${rewriteTxt(query?.cid)}`;
    } else if (rewriteTxt(query?.cid) === 'latest-news') {
      uri = `categories/${rewriteTxt(query?.cid)}`;
    } else {
      uri = `categories/${rewriteTxt(query?.cid)}/${query?.sub}`;
    }
  }

  // let olduri = null;
  // if (query?.group || query?.groups) {
  //   const _qs = query?.group || query?.groups;
  //   if (redirectPaths(_qs, 'subCategory')) {
  //     olduri = redirectPaths(_qs, 'subCategory');
  //   }
  // }
  // if (query?.old_cid || query?.all_news) {
  //   const _qc = query?.old_cid || query?.all_news;
  //   if (redirectPaths(_qc, 'category')) {
  //     olduri = redirectPaths(_qc, 'category');
  //   }
  // }

  try {
    // console.log('CATEGORY', query);
    const regex = /([ก-๙])/;
    if (regex.test(query?.cid)) {
      res.setHeader('location', '/');
      res.statusCode = 301;
      res.end();
    }
    const resData = await GET_ARTICLES(`/api/v1.0/${uri}`, false, true);
    let resDataTo = null;

    if (resData?.statusCode === 404 || isUndefined(resData)) {
      res.setHeader('location', '/');
      res.statusCode = 301;
      res.end();
      // return {
      //   notFound: true
      // };
    }

    if (!isEmpty(resData)) {
      if (isEmpty(resData?.data)) {
        resDataTo = await GET_ARTICLES(resData?.nextTo, false, true);
        // console.log('#1', resDataTo);
        initProps.articles = resDataTo?.data || [];
      } else {
        initProps.articles = resData?.data || [];
      }
      initProps.nextArticles = resData?.nextTo || resData?.links?.next || null;
      initProps.ads = resData.ads || [];
      initProps.category = resData?.category;
      initProps.subCategory = resData?.subCategory;
      initProps.lastNews = resData?.last_news || [];
      initProps.related = resData?.related || [];
      initProps.meta = resData?.meta || {};
      initProps.dataAffiliate = resData?.affiliate;
    }
  } catch (err) {
    console.log('==========> CATEGORY_LIST ERROR', err?.message);
    initProps.errMessage = err?.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
}

export default PageCategory;
